var map = {
	"./favicons/apple-touch-icon-114x114.png": 685,
	"./favicons/apple-touch-icon-120x120.png": 66,
	"./favicons/apple-touch-icon-144x144.png": 401,
	"./favicons/apple-touch-icon-152x152.png": 897,
	"./favicons/apple-touch-icon-180x180.png": 617,
	"./favicons/apple-touch-icon-57x57.png": 825,
	"./favicons/apple-touch-icon-72x72.png": 599,
	"./favicons/apple-touch-icon-76x76.png": 903,
	"./favicons/apple-touch-icon-precomposed.png": 18,
	"./favicons/apple-touch-icon.png": 114,
	"./favicons/favicon.ico": 574,
	"./logos/vzdud.png": 318,
	"./logos/vzdud.webp": 367
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 27;